import React, { useCallback, useEffect, useState } from 'react';
import Table from "./Table";
import Layout from './Layout';
import { Grid, makeStyles, TextField, CircularProgress, Button, Box, Container } from '@material-ui/core';
import Select from 'react-select';
import SearchIcon from '@material-ui/icons/Search';
import { useDispatch, useSelector } from 'react-redux';
import GetAppIcon from '@material-ui/icons/GetApp';
import { getMasterTableData } from '../ReduxStore/MastertableSlice';
import { getVendorData } from '../ReduxStore/VendorDataSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import CustomBreadcrumbs from './Breadcrumb';
import ExportProgressModal from './ExportProgressModal';


const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
        paddingBlock: 10,
        marginTop: 10,
        marginBottom: 10
    },
    searchInput: {
        // float: 'right',
        marginLeft: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    filterContainer: {
        marginBottom: theme.spacing(2),
    },
}));

const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999, // Adjust this value as needed
    }),
};


const totalcolumns = [
    { id: 'Sr.no', label: 'Sr No', minWidth: 50 },
    // { id: 'Action', label: 'Action', minWidth: 200, align: 'center' },
    // { id: 'SPOC', label: 'SPOC', minWidth: 100 },
    // { id: 'Head', label: 'Head', minWidth: 100 },
    // { id: 'AQ_CQ_SCM', label: 'AQ/CQ/SCM', minWidth: 100, align: 'center' },
    { id: 'asset_no', label: 'Asset', minWidth: 150, align: 'center' },
    { id: 'asset_text', label: 'Asset Description', minWidth: 250 },
    { id: 'storage_location', label: 'SAP Vendor Code', minWidth: 100, align: 'center' },
    { id: 'gin_no', label: 'Gin no.', minWidth: 100, align: 'center' },
    { id: 'business_unit', label: 'BusA', minWidth: 50 },
    { id: 'asset_class', label: 'Class', minWidth: 50 },
    { id: 'Class description', label: 'Class description', minWidth: 200 },
    { id: 'capitalisation_date', label: 'Capitalized on', minWidth: 150 },
    { id: 'po_no', label: 'PO No', minWidth: 100 },
    { id: 'PART NO', label: 'PART NO', minWidth: 150 },
    { id: 'project_code', label: 'Project Code', minWidth: 100 },
    { id: 'Model/ Car', label: 'Model/Car', minWidth: 150 },
    { id: 'Model/Project', label: 'Model/Project', minWidth: 200 },
    { id: 'wbs_element', label: 'WBS No.', minWidth: 100 },
    { id: 'current_apc', label: 'Current APC', minWidth: 150, align: 'center' },
    { id: 'dep_for_year', label: 'Dep. for year', minWidth: 150, align: 'center' },
    { id: 'dep_transfer', label: 'Dep.transfer', minWidth: 150, align: 'center' },
    { id: 'dep_retir', label: 'Dep.retir.', minWidth: 150, align: 'center' },

    { id: 'accumul_dep', label: 'Accumul. dep.', minWidth: 150, align: 'center' },
    { id: 'Bk_val_FYstrt', label: 'Bk.val.FY strt', minWidth: 150, align: 'center' },
    { id: 'apc_fy_start', label: 'APC FY Start', minWidth: 100, align: 'center' },
    { id: 'Curr_bk_val', label: 'Curr.bk.val.', minWidth: 150, align: 'center' },
    { id: 'dep_fy_start', label: 'Dep. FY start', minWidth: 150, align: 'center' },
    // { id: 'Project No', label: 'Project No.', minWidth: 120 },
    { id: 'serial_no', label: 'Serial No', minWidth: 150 },
    { id: 'quantity', label: 'Quantity', minWidth: 100, align: 'center' },
    { id: 'inventory_no', label: 'Inventory No', minWidth: 120, align: 'center' },
    { id: 'Taggability', label: 'Taggability', minWidth: 100 },
    { id: 'Vendor Code', label: 'Supplier Code', minWidth: 100, align: 'center' },
    { id: 'Supplier Name', label: 'Supplier Name', minWidth: 250 },
    { id: 'State / Country', label: 'State/Region Wise', minWidth: 150 },
    { id: 'rfid_tag_number', label: 'RFID NO', minWidth: 100 },
    { id: 'Material No', label: 'Material No', minWidth: 100 },
    // { id: 'BalshacctAPC', label: 'Bal.sh.acct APC', minWidth: 150, align: 'center' },
    // { id: 'CompanyCode', label: 'Company Code', minWidth: 100 },
    // { id: 'business_unit', label: 'Business Area', minWidth: 100 },
    // { id: 'Balancesheetitem', label: 'Balance sheet item', minWidth: 150 },
    // { id: 'asset_class', label: 'Asset Class', minWidth: 100 }, // comment for duplicate
    // { id: 'BSGrouping', label: 'BS Grouping', minWidth: 200 },
    // { id: 'Auditech_SelfTag', label: 'Auditech/ Self Tag', minWidth: 150 },
    // { id: 'UpdatedLocation', label: 'Updated Location', minWidth: 150 },
    // { id: 'Remark', label: 'Remark', minWidth: 150 },
    // { id: 'Location', label: 'Plant Location', minWidth: 150 },
    { id: 'Zone', label: 'Zone', minWidth: 100 },
    { id: 'Tml Spoc', label: 'TML SPOC', minWidth: 150 },
    // { id: 'Emailid', label: 'Email id', minWidth: 200 },
    // { id: 'ContactNo', label: 'Contact No', minWidth: 150 },
    // { id: 'Status', label: 'Status', minWidth: 100 },
    // { id: 'request_date', label: 'Date', minWidth: 150 },
    { id: 'acquisition', label: 'Acquisition', minWidth: 100, align: 'center' },
    // { id: 'Transfer', label: 'Transfer', minWidth: 100, align: 'center' },
    // { id: 'Retirement', label: 'Retirement', minWidth: 100, align: 'center' },

    // { id: 'FY', label: 'FY', minWidth: 150 },
    // { id: 'Capitalisation Year', label: 'Capitalisation Year', minWidth: 150 },
    { id: 'Tool Life ( No of Strokes )', label: 'Tool Life (No of Strokes)', minWidth: 200, align: 'center' },

    { id: 'request_date', label: 'ITMS Req. Date', minWidth: 100, align: 'center' },
    { id: 'request_no', label: 'ITMS Req. no', minWidth: 100, align: 'center' },
    { id: 'project_name', label: 'ITMS Project Name', minWidth: 100, align: 'center' },
    { id: 'raiser', label: 'ITMS Raiser', minWidth: 100, align: 'center' },
    { id: 'tool_po_no', label: 'ITMS Tool_Po_no', minWidth: 100, align: 'center' },
    { id: 'material_tool_no', label: 'ITMS Material_Tool_no', minWidth: 100, align: 'center' },
    { id: 'material_tool_desc', label: 'ITMS Material_Tool_desc', minWidth: 100, align: 'center' },
    { id: 'commodity', label: 'ITMS Commodity', minWidth: 100, align: 'center' },
    { id: 'mfg_location', label: 'ITMS Mfg_location', minWidth: 100, align: 'center' },
    { id: 'partno', label: 'ITMS Part No', minWidth: 100, align: 'center' },
    { id: 'to_supplier', label: 'ITMS Supplier-Name & Add.', minWidth: 100, align: 'center' },

];

const Vendorcolumns = [
    { id: 'Sr.no', label: 'Sr No', minWidth: 50 },
    { id: 'asset_no', label: 'Asset', minWidth: 150, align: 'center' },
    { id: 'asset_text', label: 'Asset Description', minWidth: 200 },
    { id: 'Vendor Code', label: 'Vendor Code', minWidth: 100, align: 'center' },
    { id: 'Supplier Name', label: 'Supplier Name', minWidth: 200 },
    { id: 'rfid_tag_number', label: 'RFID NO', minWidth: 100 },
    { id: 'business_unit', label: 'BusA', minWidth: 50 },
    { id: 'asset_class', label: 'Class', minWidth: 50 },
    { id: 'Taggability', label: 'Taggability', minWidth: 100 },
    { id: 'capitalisation_date', label: 'Capitalized on', minWidth: 150 },
    { id: 'Class description', label: 'Class description', minWidth: 200 },
    { id: 'Material No', label: 'Material No', minWidth: 200 },


];


const AsssetMaterTable = () => {
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];
    const dispatch = useDispatch();
    const [masterData, setMasterData] = useState();
    const [loading, setLoading] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [progress, setProgress] = useState();
    // const [HeadOptions, setHeadOptions] = React.useState(null);
    // const [selectedHead, setselectedHead] = React.useState(null);
    const [SupplierOptions, setSupplierOptions] = React.useState(null);
    // const [SPOCOptions, setSPOCOptions] = React.useState(null);
    // const [selectedSPOC, setselectedSPOC] = React.useState(null);
    // const [TaggabilityOptions, setTaggabilityOptions] = React.useState(null);
    // const [selectedTaggability, setselectedTaggability] = React.useState(null);
    // const [yearOptions, setYearOptions] = React.useState(null);
    // const [selectedYear, setSelectedYear] = React.useState(null);
    const [assetNo, setAssetNo] = useState("");
    const [tmlSPOC, setTMLSPOC] = useState("");
    const [assetDesc, setAssetDesc] = useState("");
    const [rfid, setRfid] = useState("");
    const [selectedSupplier, setselectedSupplier] = useState(null);
    const [selectedPlantCode, setselectedPlantCode] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [show, setShow] = useState(true);
    const [columns, setColumns] = useState([]);
    const { response } = useSelector(state => state.vendor);

    const plantCodeOptions = [
        { value: 'EP01', label: 'EV Sanand (EP01)' },
        { value: 'EP02', label: 'EV Sanand (EP02)' },
        { value: 'EC01', label: 'EV Sanand (EC01)' },
        { value: 'C010', label: 'PV Pune (C010)' },
        { value: 'C013', label: 'PV Sanand (C013)' },
    ];


    useEffect(() => {
        // const Supplierlist = response && response.map(item => item.vendor_group);
        const Supplierlist = response && response.map(item => ({
            label: `${item.vendor_group} (${item.vendor})`, // Concatenate vendor_group and vendor
            value: item.vendor // Use vendor code as the value
        }));
        console.log("Supplierlist", Supplierlist);

        // if (Supplierlist) {
        //     setSupplierOptions(Supplierlist.map((item, index) => (
        //         {
        //             value: index,
        //             label: item
        //         }
        //     )));
        // }
        if (Supplierlist) {
            // Set the supplier options for the Select component
            setSupplierOptions(Supplierlist.map((item, index) => ({
                value: item.value, // Use vendor as the value
                label: item.label  // Display concatenated vendor_group and vendor
            })));
        }
    }, [response]);



    // const handleSearchChange = (event) => {
    //     setSearchAsset(event.target.value);
    // };

    // const filteredData = masterData && masterData.filter((item) => {
    //     // const dateParts = item.Date.split(' ');
    //     // const yearPart = dateParts[dateParts.length - 1];
    //     return (
    //         // (selectedHead === null || item.Head === selectedHead.label) &&
    //         (selectedSupplier === null || item["Supplier Name"] === selectedSupplier.label) &&
    //         (selectedSPOC === null || item["Tml Spoc"] === selectedSPOC.label) &&
    //         (selectedTaggability === null || item["Taggability"] === selectedTaggability.label) &&
    //         // (selectedYear === null || yearPart === selectedYear.label) &&
    //         // ((searchAsset === "") || item.Asset.toString().includes(searchAsset))
    //         // (searchAsset === "" || item['Vendor Code'].toString().includes(searchAsset))
    //         // (searchAsset === "" || item['Vendor Group'].toString().includes(searchAsset))
    //         // (searchAsset === "" || item['Class description'].toString().includes(searchAsset))
    //         (searchAsset === "" || item['Vendor Code'].toString().includes(searchAsset)) &&
    //         (searchAsset === "" || item['Vendor Group']?.toString().includes(searchAsset)) &&
    //         (searchAsset === "" || item['Class description']?.toString().includes(searchAsset)) &&
    //         (searchAsset === "" || item['Asset']?.toString().includes(searchAsset))
    //     );
    // });

    const searchHandler = async () => {
        try {
            setLoading(true)
            // const action = dispatch(getMasterTableData({ page: 1, limit: 500, queryParams: `asset_no=${assetNo}&asset_text=${assetDesc}&vendor_code=${selectedSupplier?.value ?? ""}&rfid=${rfid}&tml_spoc=${tmlSPOC}&plant_code=${selectedPlantCode?.value ?? ""}` }));
            const action = dispatch(getMasterTableData({ page: 1, limit: 500, queryParams: `asset_no=${assetNo}&asset_text=${assetDesc}&vendor_code=${selectedSupplier?.value ?? ""}&rfid=${rfid}&tml_spoc=${tmlSPOC}&plant_code=${selectedPlantCode ? selectedPlantCode.map(p => p.value).join(",") : ""}` }));
            const res = await action.unwrap();
            console.log("ALL DATA", res.result.data)
            if (res.result.data) {
                setLoading(false)
                // Process the data to remove the first 3 letters from asset_no if it exists
                const modifiedData = res.result.data.map(item => ({
                    ...item,
                    asset_no: item.asset_no ? item.asset_no.slice(3) : item.asset_no
                }));

                if (res.result.data.length > 0) {
                    // setMasterData(res.result.data)
                    setMasterData(modifiedData)
                    setTotalRecords(res.result.total_rows);
                } else {
                    toast.info("Asset Not Found!")
                }
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Asset Not Found!");
        } finally {
            setLoading(false)
        }
    }

    const getAssetMasrter = useCallback(async (page, limit) => {
        try {
            const action = dispatch(getMasterTableData({ page: page + 1, limit }));
            const res = await action.unwrap();
            console.log("ALL DATA---------", res.result.data)
            if (res.result) {
                // Process the data to remove the first 3 letters from asset_no if it exists
                const modifiedData = res.result.data.map(item => ({
                    ...item,
                    asset_no: item.asset_no ? item.asset_no.slice(3) : item.asset_no
                }));
                if (res.result.vendor_login === true) {
                    setShow(false)
                    setColumns(Vendorcolumns)
                } else {
                    setShow(true)
                    setColumns(totalcolumns)
                }
                // setMasterData(res.result.data)
                setMasterData(modifiedData)
                setTotalRecords(res.result.total_rows);

            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went Wrong!");
        }
    }, [dispatch])

    useEffect(() => {
        dispatch(getVendorData());
    }, [dispatch])

    // useEffect(() => {
    //     const fetchData = async () => {
    //         await getAssetMasrter();
    //         setLoading(false);
    //     };
    //     fetchData();
    // }, [])



    const exportCurrentData = async () => {
        setExportLoading(true);
        setProgress(0);

        const modifiedData = masterData.map(item => ({
            ...item,
            asset_code_no: item.asset_code_no ? item.asset_code_no.slice(3) : item.asset_code_no
        }));

        const worksheet = XLSX.utils.json_to_sheet(modifiedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        XLSX.writeFile(workbook, 'Asset_master_current.xlsx');

        toast.success("Exported successfully!");
        setExportLoading(false)

    };

    // Function to export data to Excel
    const exportToExcel = async () => {
        let page = 0;
        const limit = 10000; // Page size
        let allData = []; // Array to store all fetched data
        let totalPages = 1; // Initialize total pages

        setExportLoading(true); // Show the modal
        setProgress(0); // Reset progress

        try {
            do {
                // Fetch paginated data
                const action = dispatch(getMasterTableData({ page: page + 1, limit }));
                const res = await action.unwrap();

                if (res.result) {
                    const { data, total_rows, total_pages } = res.result;

                    // Aggregate data
                    allData = [...allData, ...data];

                    // Set total pages and total rows on the first fetch
                    if (page === 0) {
                        totalPages = total_pages;
                    }

                    // Calculate progress percentage
                    const percentage = Math.min(((page + 1) / totalPages) * 100, 100);
                    setProgress(percentage); // Update progress bar

                    // Process each page data if necessary
                    // console.log(`Fetched page ${page + 1} of ${totalPages}`);

                    // Increment page number
                    page++;
                } else {
                    throw new Error("Failed to fetch data from the API");
                }
            } while (page < totalPages); // Continue until all pages are fetched

            // Modify the data (e.g., remove first 3 characters from asset_no)
            const modifiedData = allData.map(item => ({
                ...item,
                asset_no: item.asset_no ? item.asset_no.slice(3) : item.asset_no
            }));
            // Create a worksheet from the aggregated and modified data
            const worksheet = XLSX.utils.json_to_sheet(modifiedData);

            // Create a new workbook and append the worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // Generate a buffer and trigger the download
            XLSX.writeFile(workbook, 'Asset_Master.xlsx');

            toast.success("Exported successfully!");
            setExportLoading(false)
        } catch (error) {
            console.error("Error while exporting data:", error);
            toast.error(error.message || "Something went wrong while exporting!");
        } finally {
            setExportLoading(false); // Hide the modal
            setProgress(0); // Reset progress
        }
    };


    return (
        <Layout>
            <Container>
                {/* Export Progress Modal */}
                <ExportProgressModal open={exportLoading} progress={progress} />
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Asset Master Table" />
                </Box>
                <Box mt={1} mb={1}>
                    <Grid container spacing={2}>
                        {show &&
                            <Grid item xs={12} sm={2}>
                                <Select
                                    styles={customStyles}
                                    options={SupplierOptions}
                                    placeholder="Select Vendor"
                                    isSearchable
                                    onChange={setselectedSupplier}
                                    isClearable
                                />
                            </Grid>}
                        <Grid item xs={12} sm={2}>
                            <Select
                                isMulti
                                styles={customStyles}
                                options={plantCodeOptions}
                                placeholder="Select Plant Code"
                                isSearchable
                                onChange={setselectedPlantCode}
                                isClearable
                            />

                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                // className={classes.searchInput}
                                placeholder="Search by Rfid"
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={rfid}
                                onChange={(e) => setRfid(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                // className={classes.searchInput}
                                placeholder="Search by Asset Desc."
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={assetDesc}
                                onChange={(e) => setAssetDesc(e.target.value)}
                            // InputProps={{
                            //     endAdornment: (
                            //         <InputAdornment position="end">
                            //             <SearchIcon />
                            //         </InputAdornment>
                            //     ),
                            // }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                // className={classes.searchInput}
                                placeholder="Search by Asset No"
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={assetNo}
                                onChange={(e) => setAssetNo(e.target.value)}
                            />
                        </Grid>
                        {show &&
                            <Grid item xs={12} sm={2}>
                                <TextField
                                    placeholder="Search by TML SPOC"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={tmlSPOC}
                                    onChange={(e) => setTMLSPOC(e.target.value)}
                                />
                            </Grid>
                        }

                        <Grid item xs={12} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                fullWidth
                                color="primary"
                                onClick={searchHandler}
                                // endIcon={<SearchIcon />}
                                endIcon={loading ? <CircularProgress size={20} /> : <SearchIcon />}
                                disabled={loading} // Optionally disable the button when loading
                            >
                                {loading ? "Searching" : "Search"}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Button
                                type="button"
                                variant="contained"
                                fullWidth
                                color="primary"
                                onClick={exportCurrentData}
                                endIcon={<GetAppIcon />}
                            >
                                Export Current Data
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                fullWidth
                                color="primary"
                                onClick={exportToExcel}
                                endIcon={<GetAppIcon />}
                            >
                                Export All
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Table data={masterData} columns={columns} fetchData={getAssetMasrter} totalRecords={totalRecords} isServerSide={true} />
                    </Grid>
                </Grid>

                <ToastContainer />
            </Container>
        </Layout>
    );
};

export default AsssetMaterTable;